// @flow
import NumberAttributeModel from "./NumberAttributeModel";

import { ATTRIBUTE_WIDTH } from "../../constants";

/**
 * Money Attribute model
 */
export default class MoneyAttributeModel extends NumberAttributeModel {
  /**
   */
  static isApplicableModel(contributions: Object): boolean {
    const layouthint = contributions?.layouthint;
    return (
      contributions.type === "money" ||
      (Array.isArray(layouthint) && layouthint.includes("money"))
    );
  }

  /**
   */
  get type(): string {
    return "money";
  }

  /**
   * Retrieve currency symbol
   */
  get currencySymbol(): string {
    return this.getContribution("currencySymbol", "");
  }

  /**
   * Retrieve currency symbol as prefix
   */
  get prefix(): string {
    return this.currencySymbol;
  }

  /**
   */
  get readonlyWidth(): $Keys<typeof ATTRIBUTE_WIDTH> {
    return ATTRIBUTE_WIDTH.SMALL;
  }
}
